import { useContext } from 'react';
import { RegisterContext } from '@wearejh/m2-pwa-engine/lib/components';

import { Deps } from '../types/global-types';

export function useDeps(): Deps {
    const { epicDeps } = useContext(RegisterContext);
    return epicDeps as Deps;
}
